﻿/* This class represents a lead of type Tour Lead for a plan. */
export default class PlanTourLead {
    constructor(formData) {
      this.planId = formData.id;
      this.mailAddress = formData.email;
      this.name = formData.name;
      this.type = 'postPlanBrochure';
      this.userPhoneNumber = formData.phone;
      this.leadAction = formData.leadAction;
      this.preferredContactMethod = formData.preferredContactMethod;
      this.date = formData.date;
      this.excludeRecommendations = formData.excludeRecommendations;
  
      if (formData.postalCode) {
        this.userPostalCode = formData.postalCode;
      } else {
        this.livesOutside = true;
      }
    }
    
    setHousingInformation(properties) {
      this.marketId = properties.marketId;
      this.marketName = properties.marketName;
      this.builderName = properties.brandName;
      this.communityName = properties.communityName;
      this.communityId = properties.communityId;
    }
  }
  